module.exports = __webpack_public_path__ + "static/media/Simbolo_Gaia.6e72e8eb.png";